import React from 'react';
import { exhaustiveGuard } from '@soundxyz/utils';
import type { Chains } from '@soundxyz/utils/const';
import { DataTestId } from '@utils/test';

export const EthereumIndicator = ({ inverted = false }: { inverted?: boolean }) => (
  <svg
    data-testid={DataTestId.ETHEREUM_NETWORK}
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_142_50329)">
      <rect width="21" height="22" rx="10.5" fill={inverted ? 'white' : 'black'} />
      <path
        d="M10.4989 4.25146V9.24084L14.716 11.1252L10.4989 4.25146Z"
        fill={inverted ? 'black' : 'white'}
      />
      <path
        d="M10.4989 4.25146L6.28125 11.1252L10.4989 9.24084V4.25146Z"
        fill={inverted ? 'black' : 'white'}
      />
      <path
        d="M10.4989 14.3582V17.7483L14.7188 11.9102L10.4989 14.3582Z"
        fill={inverted ? 'black' : 'white'}
      />
      <path
        d="M10.4989 17.7483V14.3576L6.28125 11.9102L10.4989 17.7483Z"
        fill={inverted ? 'black' : 'white'}
      />
      <path
        d="M10.4989 13.5735L14.716 11.1249L10.4989 9.2417V13.5735Z"
        fill={inverted ? 'black' : 'white'}
      />
      <path
        d="M6.28125 11.1249L10.4989 13.5735V9.2417L6.28125 11.1249Z"
        fill={inverted ? 'black' : 'white'}
      />
    </g>
    <defs>
      <filter
        id="filter0_b_142_50329"
        x="-24"
        y="-24"
        width="69"
        height="70"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_142_50329" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_142_50329"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const OptimismIndicator = ({ inverted = false }: { inverted?: boolean }) => (
  <svg
    data-testid={DataTestId.OPTIMISM_NETWORK}
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_108_68484)">
      <rect width="21" height="22" rx="10.5" fill={inverted ? 'white' : 'black'} />
      <path
        d="M6.1488 14.7829C5.3144 14.7829 4.6312 14.5869 4.0992 14.1949C3.5728 13.7973 3.3096 13.2261 3.3096 12.4925C3.3096 12.3357 3.3264 12.1509 3.36 11.9269C3.4496 11.4229 3.5784 10.8181 3.7464 10.1069C4.2224 8.18048 5.4544 7.21729 7.4368 7.21729C7.9744 7.21729 8.4616 7.30688 8.8872 7.49168C9.3128 7.66528 9.6488 7.93409 9.8952 8.29249C10.1416 8.64529 10.2648 9.06529 10.2648 9.55249C10.2648 9.69809 10.248 9.88288 10.2144 10.1069C10.108 10.7285 9.9848 11.3389 9.8336 11.9269C9.5872 12.8845 9.1672 13.6069 8.5624 14.0829C7.9632 14.5533 7.1568 14.7829 6.1488 14.7829ZM6.3 13.2709C6.692 13.2709 7.0224 13.1533 7.2968 12.9237C7.5768 12.6941 7.7784 12.3413 7.896 11.8597C8.0584 11.1989 8.1816 10.6277 8.2656 10.1349C8.2936 9.98928 8.3104 9.83809 8.3104 9.68129C8.3104 9.04289 7.98 8.72368 7.3136 8.72368C6.9216 8.72368 6.5856 8.84128 6.3056 9.07088C6.0312 9.30048 5.8352 9.65328 5.7176 10.1349C5.5888 10.6053 5.4656 11.1765 5.3368 11.8597C5.3088 11.9997 5.292 12.1453 5.292 12.3021C5.2864 12.9517 5.628 13.2709 6.3 13.2709Z"
        fill={inverted ? 'black' : 'white'}
      />
      <path
        d="M10.752 14.6821C10.6736 14.6821 10.6176 14.6597 10.5728 14.6093C10.5392 14.5533 10.528 14.4917 10.5392 14.4189L11.9896 7.58693C12.0008 7.50853 12.04 7.44693 12.1072 7.39653C12.1688 7.34613 12.236 7.32373 12.3088 7.32373H15.1032C15.8816 7.32373 16.5032 7.48613 16.9736 7.80533C17.4496 8.13013 17.6904 8.59493 17.6904 9.20533C17.6904 9.37893 17.668 9.56373 17.6288 9.75413C17.4552 10.5605 17.1024 11.1541 16.5648 11.5405C16.0384 11.9269 15.316 12.1173 14.3976 12.1173H12.9808L12.4992 14.4189C12.4824 14.4973 12.4488 14.5589 12.3816 14.6093C12.32 14.6597 12.2528 14.6821 12.18 14.6821H10.752ZM14.4704 10.6669C14.7672 10.6669 15.0192 10.5885 15.2376 10.4261C15.4616 10.2637 15.6072 10.0341 15.68 9.73173C15.7024 9.61413 15.7136 9.50773 15.7136 9.41813C15.7136 9.21653 15.652 9.05973 15.5344 8.95333C15.4168 8.84133 15.2096 8.78533 14.924 8.78533H13.664L13.2664 10.6669H14.4704Z"
        fill={inverted ? 'black' : 'white'}
      />
    </g>
    <defs>
      <filter
        id="filter0_b_108_68484"
        x="-24"
        y="-24"
        width="69"
        height="70"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_108_68484" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_108_68484"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export function IndicatorForChain({ chain }: { chain: Chains }) {
  switch (chain) {
    case 'MAINNET':
    case 'GOERLI':
      return <EthereumIndicator />;

    case 'OPTIMISM':
    case 'OPTIMISM_GOERLI':
      return <OptimismIndicator />;
    default:
      exhaustiveGuard(chain);
  }
}
